import { BaseModule } from '../app';

export default class Config {
    static PASSWORD_RE = /^(?=.*[a-z])(?=.*\d).{8,}$/i;
    static PASSWORD_MSG = '비밀번호는 영문과 숫자를 포함해 8자 이상이어야 합니다.';

    static isEventDebug = false; // 커스텀 이벤트 출력(디버깅) 여부
}